import {Component, Input, OnInit} from '@angular/core';
import {ShopCartService} from "./shop.cart.service";
import { ShopProductService } from './shop.product.service';

@Component({
    selector: 'shop-cart-icon',
    templateUrl: './shop.cart.icon.component.html',
    providers: []
})
export class ShopCartIconComponent implements OnInit {

    /**
     * currency for the shop
     */
    @Input() currency: string;

    /**
     * Current number of products in the cart
     */
    itemCount: number = 0;

    /**
     * overall price of the cart items.
     */
    price: number = 0;

    /**
     * toggle for an indicator class that an item was added.
     */
    added: boolean = false;

    /**
     * format for the price with or without decimals
     */
    priceFormat: string = '1.0-0';

    /**
     * constructor
     * @param cartService
     */
    constructor(private cartService: ShopCartService, private shopProductService: ShopProductService) {}

    /**
     * @inheritDoc
     */
    ngOnInit(): void {
        // get initial number of items
        this.itemCount = this.cartService.getOverallCount();
        this.price = this.cartService.getPrice();

        this.shopProductService.getDecimalsShownCart().subscribe((decimalsShown) => {
            this.priceFormat = decimalsShown ? '1.2-2' : '1.0-0';
        });

        // update the number of items every time someting changed
        this.cartService.itemsUpdated.subscribe(() => {
            this.itemCount = this.cartService.getOverallCount();
            this.price = this.cartService.getPrice();
            this.added = true;
            setTimeout(() => this.added = false, 500);
        });
    }
}
